module.exports = __webpack_public_path__ + "static/img/yewei3.a2f9c816.png";